import React from 'react';
import '../App.css';
import { headerStyling, subheaderStyling } from '../App';
import scribble from '../images/scribble.png'

function Home() {
    return (
        <div className="App-body">
            <p style={headerStyling}>
                I'm Bhargav!
            </p>
            <p style={subheaderStyling}>
                I'm a freelance musician, composer, producer, coder and writer, and I'm available for work!
            </p>
            <p style={subheaderStyling}>
                I built this website to meet collaborators and showcase what I'm up to.
            </p>
            <p style={subheaderStyling}>
                Let's jam!
            </p>
            <img src={scribble} alt="" style={{ height: "200px" }} onContextMenu={() => { return false; }} draggable={false} />
        </div>
    );
}

export default Home;